"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateDatasetDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var react_intl_1 = require("react-intl");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var utils_1 = require("./utils");
var DEFAULT_HYPHEN_CHAR = "-";
var alignPoints = [{ align: "bl tl" }, { align: "tl bl" }];
var tooltipAlignPoints = [
    { align: "cl cr", offset: { x: -10, y: 0 } },
    { align: "cr cl", offset: { x: 10, y: 0 } },
];
// work around the evil DateDatasetsListItem from kit that magically translates SOME of the items' titles
// this way the i18n actually has a chance to detect these
var dateDatasetHeaderMessages = react_intl_1.defineMessages({
    "gs.date.date-dataset.recommended": { id: "gs.date.date-dataset.recommended" },
    "gs.date.date-dataset.other": { id: "gs.date.date-dataset.other" },
    "gs.date.date-dataset.related": { id: "gs.date.date-dataset.related" },
    "gs.date.date-dataset.unrelated": { id: "gs.date.date-dataset.unrelated" },
});
var DateDatasetsListItem = function (_a) {
    var id = _a.id, _b = _a.title, title = _b === void 0 ? "" : _b, isHeader = _a.isHeader, isSelected = _a.isSelected, isUnrelated = _a.isUnrelated, onClick = _a.onClick;
    if (isHeader) {
        return react_1.default.createElement("div", { className: "gd-list-item gd-list-item-header" }, title);
    }
    var classNames = classnames_1.default("gd-list-item", "gd-list-item-shortened", "s-" + id, "s-" + util_1.stringUtils.simplifyText(title), {
        "is-selected": isSelected,
        "is-unrelated": isUnrelated,
    });
    return (react_1.default.createElement("div", { className: classNames, onClick: onClick },
        react_1.default.createElement(sdk_ui_kit_1.ShortenedText, { tooltipAlignPoints: tooltipAlignPoints }, title)));
};
function catalogDateDatasetToDateDataset(ds) {
    return {
        id: ds.dataSet.id,
        title: ds.dataSet.title,
        relevance: ds.relevance,
    };
}
exports.DateDatasetDropdown = function (props) {
    var _a = props.className, className = _a === void 0 ? "s-date-dataset-switch" : _a, _b = props.isLoading, isLoading = _b === void 0 ? false : _b, _c = props.autoOpen, autoOpen = _c === void 0 ? false : _c, onDateDatasetChange = props.onDateDatasetChange, activeDateDataset = props.activeDateDataset, unrelatedDateDataset = props.unrelatedDateDataset, width = props.width, dateFromVisualization = props.dateFromVisualization, relatedDateDatasets = props.relatedDateDatasets, widgetRef = props.widgetRef;
    var intl = react_intl_1.useIntl();
    var setScrollElement = useAutoscroll(autoOpen);
    var unrelatedDateDataSetId = unrelatedDateDataset ? unrelatedDateDataset.dataSet.id : null;
    var activeDateDataSetId;
    var activeDateDataSetTitle = DEFAULT_HYPHEN_CHAR;
    var activeDateDataSetUri;
    var recommendedDateDataSet = null;
    if (!isLoading && activeDateDataset) {
        activeDateDataSetId = activeDateDataset.dataSet.id;
        activeDateDataSetTitle = activeDateDataset.dataSet.title;
        activeDateDataSetUri = activeDateDataset.dataSet.uri;
    }
    if (dateFromVisualization) {
        recommendedDateDataSet = relatedDateDatasets.find(function (d) { return d.dataSet.uri === dateFromVisualization.dataSet.uri; });
    }
    var sortedItems = sdk_ui_kit_1.sortDateDatasets(relatedDateDatasets.map(catalogDateDatasetToDateDataset), recommendedDateDataSet ? catalogDateDatasetToDateDataset(recommendedDateDataSet) : undefined, unrelatedDateDataset ? catalogDateDatasetToDateDataset(unrelatedDateDataset) : undefined);
    return (react_1.default.createElement(sdk_ui_kit_1.Dropdown
    // We want to open the dropdown, when user selects a metric
    // without a recommended data set
    , { 
        // We want to open the dropdown, when user selects a metric
        // without a recommended data set
        key: sdk_model_1.objRefToString(widgetRef) + "_" + autoOpen, openOnInit: autoOpen, ignoreClicksOnByClass: [".dash-content"], renderButton: function (_a) {
            var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
            var buttonClassName = classnames_1.default("s-date-dataset-button", isOpen ? "s-expanded" : "s-collapsed", {
                "is-loading": isLoading,
                "is-unrelated": !isLoading &&
                    unrelatedDateDataset &&
                    unrelatedDateDataset.dataSet.uri === activeDateDataSetUri,
            });
            var buttonValue = isLoading
                ? intl.formatMessage({ id: "loading" })
                : utils_1.removeDateFromTitle(activeDateDataSetTitle);
            return (react_1.default.createElement("span", { ref: setScrollElement },
                react_1.default.createElement(sdk_ui_kit_1.DropdownButton, { className: buttonClassName, value: buttonValue, isOpen: isOpen, onClick: toggleDropdown, disabled: isLoading })));
        }, className: className, closeOnParentScroll: true, closeOnMouseDrag: true, alignPoints: alignPoints, renderBody: function (_a) {
            var closeDropdown = _a.closeDropdown;
            if (isLoading) {
                return null;
            }
            return (react_1.default.createElement(sdk_ui_kit_1.DropdownList, { className: "configuration-dropdown dataSets-list", width: width, items: sortedItems, itemsCount: sortedItems.length, renderItem: function (_a) {
                    var item = _a.item;
                    var isHeader = sdk_ui_kit_1.isDateDatasetHeader(item);
                    var isSelected = !sdk_ui_kit_1.isDateDatasetHeader(item) && activeDateDataSetId === item.id;
                    var isUnrelated = !sdk_ui_kit_1.isDateDatasetHeader(item) && unrelatedDateDataSetId === item.id;
                    return (react_1.default.createElement(DateDatasetsListItem, { title: isHeader
                            ? intl.formatMessage(dateDatasetHeaderMessages[item.title])
                            : utils_1.removeDateFromTitle(item.title), isHeader: isHeader, isSelected: isSelected, isUnrelated: isUnrelated, onClick: function (e) {
                            e.preventDefault();
                            if (sdk_ui_kit_1.isDateDatasetHeader(item)) {
                                return;
                            }
                            closeDropdown();
                            onDateDatasetChange(item.id);
                        } }));
                } }));
        } }));
};
function useAutoscroll(autoscroll) {
    var _a = tslib_1.__read(react_1.useState(null), 2), ref = _a[0], setRef = _a[1];
    react_1.useEffect(function () {
        if (ref && autoscroll) {
            ref.scrollIntoView();
        }
    }, [ref, autoscroll]);
    return setRef;
}
//# sourceMappingURL=DateDatasetDropdown.js.map